<div [ngClass]="['w-full relative', opened ? 'highlight' : '', active ? 'active' : '']" aipbHoverHighlight>
  <cat-header
    (action)="detail.emit($event)"
    [coreId]="coreId"
    [enablePin]="true"
    [header]="item.header"
    [highlighting]="highlighting"
    [item]="item"
    [sort]="sort"
  ></cat-header>

  <aipb-inside-loading [loading]="loading" diameter="20"></aipb-inside-loading>
</div>
